import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import styles from "./PartialImportConfirmModal.module.css";

interface PartialImportConfirmModalProps {
  isOpen: boolean;
  validCount: number;
  skippedCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export function PartialImportConfirmModal({
  isOpen,
  validCount,
  skippedCount,
  onCancel,
  onConfirm,
}: PartialImportConfirmModalProps) {
  const importLabel = validCount === 1 ? "row" : "rows";
  const skippedLabel = skippedCount === 1 ? "row" : "rows";

  return (
    <Modal isOpen={isOpen}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <Heading slot="title">Import valid rows?</Heading>
        </div>

        <ul className={styles.summary}>
          <li className={`${styles.summaryItem} ${styles.itemSuccess}`}>
            <span className={styles.itemIcon} aria-hidden="true">✓</span>
            <span className={styles.itemCount}>{validCount}</span>
            <span className={styles.itemLabel}>
              valid {importLabel} will be imported
            </span>
          </li>
          <li className={`${styles.summaryItem} ${styles.itemDanger}`}>
            <span className={styles.itemIcon} aria-hidden="true">✕</span>
            <span className={styles.itemCount}>{skippedCount}</span>
            <span className={styles.itemLabel}>
              {skippedLabel} skipped — download the errors CSV, fix, and re-upload
            </span>
          </li>
        </ul>

        <div className={styles.actions}>
          <ButtonGroup>
            <Button variant="tertiary" onPress={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" onPress={onConfirm}>
              Import valid rows
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
